import * as React from "react"
import { GiftoinList } from "../list"

export const GiftoinSettings: React.FunctionComponent = () => {
  return (
    <GiftoinList />
  )
}
